import { render, staticRenderFns } from "./PoiPicker.vue?vue&type=template&id=645b421e&scoped=true&"
import script from "./PoiPicker.vue?vue&type=script&lang=js&"
export * from "./PoiPicker.vue?vue&type=script&lang=js&"
import style0 from "./PoiPicker.vue?vue&type=style&index=0&id=645b421e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b421e",
  null
  
)

export default component.exports